import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, DialogContent, Drawer, Link } from '@mui/material';
import LogoImageSrc from 'src/assets/images/innerwave_logo.png';
import { DialogAnimate } from 'src/components/animate';
import DialogTitleWithCloseButton from 'src/components/dialog/DialogTitleWithCloseButton';
import useNavData from 'src/hooks/useNavData';
import { PATH_PAGE } from 'src/routes/paths';
import ChangeLog from 'src/screens/common/ChangeLog';
// config
import { NAV } from 'src/static/constants';

// components
import { NavSectionVertical } from '../../../components/nav-section';
import Scrollbar from '../../../components/scrollbar';
// hooks
import useResponsive from '../../../hooks/useResponsive';

import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
  onOpenMyInfoModal?: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav, onOpenMyInfoModal }: Props) {
  const { pathname } = useLocation();
  const navData = useNavData();

  const isDesktop = useResponsive('up', 'lg');

  const [openChangeLog, setOpenChangeLog] = useState(false);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box sx={{ px: 2.5, pt: 2.5, pb: 0.5 }}>
        <Link
          component={RouterLink}
          to={PATH_PAGE.management.report.root}
          sx={{ display: 'block' }}
        >
          <img src={LogoImageSrc} alt="logo" style={{ width: 110, height: 'auto' }} />
        </Link>
      </Box>
      <Box sx={{ px: 2, pt: 3, pb: 1.5, flexShrink: 0 }}>
        <NavAccount onOpenMyInfoModal={onOpenMyInfoModal} />
      </Box>
      {/* {isDesktop && <SearchInput />} */}
      <NavSectionVertical data={navData} />
      {/* <OpenAiForm /> */}
      <Box sx={{ flexGrow: 1, minHeight: 100 }} />
      <Link sx={{ alignSelf: 'center', pb: 2 }} onClick={() => setOpenChangeLog((prev) => !prev)}>
        Changelog
      </Link>
    </Scrollbar>
  );
  const closeChangeLog = () => setOpenChangeLog(false);

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
      {isDesktop && <NavToggleButton />}
      <DialogAnimate
        fullWidth
        maxWidth="md"
        open={openChangeLog}
        onClose={closeChangeLog}
        scroll="paper"
        sx={{ height: '100%' }}
      >
        <DialogTitleWithCloseButton
          title={`Works Changelog`}
          onClose={closeChangeLog}
        ></DialogTitleWithCloseButton>
        <DialogContent dividers>
          <ChangeLog />
        </DialogContent>
      </DialogAnimate>
    </Box>
  );
}
